import { pushDataLayerEvent } from '@/helpers/client/analytics/data-layer';
import { convertToGa4Item } from '@/helpers/google-analytics';

export const triggerViewItemList = ({ itemListName, products }) => {
  pushDataLayerEvent({
    event: 'view_item_list',
    ecommerce: {
      item_list_name: itemListName,
      items: products.map((product) => {
        return convertToGa4Item({ product });
      }),
    },
  });
};

export const triggerSelectItem = ({ itemListName, product }) => {
  pushDataLayerEvent({
    event: 'select_item',
    ecommerce: {
      item_list_name: itemListName,
      items: [convertToGa4Item({ product })],
    },
  });
};

export const triggerViewItem = ({ product }) => {
  if (product) {
    const item = convertToGa4Item({ product });

    pushDataLayerEvent({
      event: 'view_item',
      ecommerce: {
        value: item.price,
        currency: item.currency,
        items: [item],
      },
    });
  }
};

export const triggerViewCart = (cartData) => {
  // const items = cartData.lines.edges.map((line) => {
  //   const shopifyProduct = line.node.merchandise.product;
  //   const variant = findCartLineVariant(line);
  //   const item = convertToGa4Item({
  //     shopifyProduct,
  //     variant,
  //   });
  //   return {
  //     ...item,
  //     quantity: line.node.quantity,
  //   };
  // });
  // pushDataLayerEvent({
  //   event: 'view_cart',
  //   ecommerce: {
  //     value: parseFloat(cartData.cost.totalAmount.amount),
  //     currency: cartData.cost.totalAmount.currencyCode,
  //     items,
  //   },
  // });
};

export const triggerCartVariation = ({ event, product, variant, quantity }) => {
  const item = convertToGa4Item({
    product,
    variant,
    quantity,
  });

  const value = item.price * quantity;

  pushDataLayerEvent({
    event,
    ecommerce: {
      value,
      currency: item.currency,
      items: [item],
    },
  });
};

export const triggerAddToCart = ({ product, variant, quantity }) => {
  triggerCartVariation({
    event: 'add_to_cart',
    product,
    variant,
    quantity,
  });
};

export const triggerRemoveFromCart = ({
  shopifyProduct,
  variant,
  quantity,
}) => {
  // triggerCartVariation({
  //   event: 'remove_from_cart',
  //   shopifyProduct,
  //   variant,
  //   quantity,
  // });
};
